import React, { useContext, createContext } from "react";
import useLocalStorage from "./use-localstorage";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";

const AuthContext = createContext();
const useAuth = () => useContext(AuthContext);

const useAuthProvider = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies, setCookie, removeCookie] = useCookies(["creCareToken"]);

  // localstorage
  const [memberId, setMemberId, removeMemberId] = useLocalStorage(
    "memberId",
    null
  );
  const [memberName, setMemberName, removeMemberName] = useLocalStorage(
    "memberName",
    null
  );
  const [token, setToken, removeToken] = useLocalStorage(
    "cre-joint-token",
    null
  );

  // 登出
  const signOut = () => {
    removeMemberId();
    removeMemberName();
    removeToken();
    removeCookie("cres_token")

    const aryPath = location.pathname.split("/");
    const tmpEDepartmentId =
      aryPath.length >= 2 ? aryPath[aryPath.length - 2] : "";
    navigate(`/${tmpEDepartmentId}/login`);
  };

  // 登入
  const setAuthToken = (inputToken) => {
    setToken(inputToken);
  };

  const localStore = (result) => {
    setMemberId(result.memberId);
    setMemberName(result.memberName);
    setAuthToken(result.appToken);
  };

  return {
    token,
    setToken,
    removeToken,
    setAuthToken,
    localStore,
    signOut,
    memberId,
    setMemberId,
    memberName,
    setMemberName,
  };
};

const AuthProvider = ({ children }) => {
  const auth = useAuthProvider();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export default useAuth;
export { AuthProvider };
